export const renameStatus = (status) => {
    if (status === "Available Now") {
        //return "Available";
        return "Vacancy";
    } else if (status === "Available") {
        //return "Available";
        return "Vacancy";
    } else if (status === "Available Soon") {
        return "Vacancy Soon";
    } else if (status === "Coming Soon") {
        return "Vacancy Soon";
    } else {
        return status;
    }
};
